/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var WorkflowVoteType;
(function (WorkflowVoteType) {
    WorkflowVoteType[WorkflowVoteType["AnyVote"] = 0] = "AnyVote";
    WorkflowVoteType[WorkflowVoteType["AndVote"] = 1] = "AndVote";
})(WorkflowVoteType || (WorkflowVoteType = {}));
export var WorkflowRetractRule;
(function (WorkflowRetractRule) {
    /** - 不允许撤回 */
    WorkflowRetractRule[WorkflowRetractRule["RetractNotAllowed"] = 1] = "RetractNotAllowed";
    /** - 仅发起节点撤回 */
    WorkflowRetractRule[WorkflowRetractRule["RetractOnlyStartNode"] = 2] = "RetractOnlyStartNode";
    /** - 允许所有节点撤回 */
    WorkflowRetractRule[WorkflowRetractRule["RetractAllNodes"] = 3] = "RetractAllNodes";
})(WorkflowRetractRule || (WorkflowRetractRule = {}));
export var WorkflowAutoApproveRule;
(function (WorkflowAutoApproveRule) {
    /** - 负责人与上一节点相同 */
    WorkflowAutoApproveRule[WorkflowAutoApproveRule["AutoApproveSameApprover"] = 1] = "AutoApproveSameApprover";
    /** - 负责人处理该流程 */
    WorkflowAutoApproveRule[WorkflowAutoApproveRule["AutoApproveCurrentNode"] = 2] = "AutoApproveCurrentNode";
    /** - 不启用 */
    WorkflowAutoApproveRule[WorkflowAutoApproveRule["AutoApproveDisabled"] = 3] = "AutoApproveDisabled";
})(WorkflowAutoApproveRule || (WorkflowAutoApproveRule = {}));
